import { ReactElement, useState, VFC } from 'react';
import { useTranslation } from 'next-i18next';
import { Formik } from 'formik';
import cn from 'classnames';
import * as Yup from 'yup';

import { Button } from 'ui';
import trackUserEvent from '@/util/eventTracking';

import newsletterForm from '@/util/newsletterForm';

const FormSchema = Yup.object().shape({
  email: Yup.string().email().required(),
});

/**
 * @component
 */
const HeroFormEmail: VFC = (): ReactElement => {
  const { t } = useTranslation('homepage');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState<{
    text: string;
    className: string;
    final: boolean;
  }>();

  return (
    <>
      <p className="mb-[12px] block desktop:mb-3">
        {!submitted ? (
          <span className="text-gray-3">{t('hero.form_email.offer')}</span>
        ) : (
          <span className={cn(feedback?.className)}>{feedback?.text}</span>
        )}
      </p>

      <Formik
        initialValues={{
          email: '',
        }}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={FormSchema}
        onSubmit={(props) =>
          newsletterForm(t, props, setLoading, setFeedback, setSubmitted, 'general')
        }
      >
        {(props) => (
          <form
            className="flex w-full flex-col gap-[8px] text-body-1  mobile:flex-row tablet:h-[57px] desktop:max-w-[618px]"
            onSubmit={props.handleSubmit}
          >
            <input
              className={cn(
                `h-[57px] grow rounded-lg placeholder:text-black focus:placeholder:text-gray-5 border-0 bg-gray-7 py-3 px-4 transition focus:outline-none focus:ring-1 focus:ring-black mobile:flex-[5]`,
                { 'ring-1 ring-red-4 focus:ring-red-4': props.errors.email },
              )}
              id="email"
              type="email"
              disabled={loading || feedback?.final}
              placeholder={t('hero.form_email.placeholder')}
              onChange={props.handleChange}
              value={props.values.email}
            />
            <Button
              className={cn(
                'h-[57px] w-full flex-1 shrink-0 min-w-[fit-content_!important] whitespace-nowrap mobile:mt-0 mobile:min-w-[132px]',
              )}
              onClick={() =>
                trackUserEvent('[Newsletter Form] Submission Attempt', {
                  location: 'hero',
                })
              }
              variant="primary"
              type="submit"
              disabled={loading || feedback?.final}
            >
              {!loading ? t('hero.form_email.button') : '...'}
            </Button>
          </form>
        )}
      </Formik>
    </>
  );
};

export default HeroFormEmail;
